<section class=" container">
  <div class="row">
    <div class="col-12 col-md-2">
      <div>
        <h3>وضعیت درخواست</h3>
        <div class="group-box">
          <label><input type="checkbox" class="form-control" (change)="toggleStatus(0)"> بررسی نشده</label>
          <label><input type="checkbox" class="form-control" (change)="toggleStatus(1)"> تایید شده</label>
          <label><input type="checkbox" class="form-control" (change)="toggleStatus(2)"> رد شده</label>
          <label><input type="checkbox" class="form-control" (change)="toggleStatus(3)"> استخدام شده</label>
        </div>
      </div>
      <div class="mt-3">
        <h3>امتیاز کارجو</h3>
        <div class="group-box">
          <label><input type="checkbox" class="form-control" (change)="toggleScore(0)"> ضعیف</label>
          <label><input type="checkbox" class="form-control" (change)="toggleScore(5)"> متوسط</label>
          <label><input type="checkbox" class="form-control" (change)="toggleScore(10)"> خوب</label>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
        </div>
        <div class="col-12 col-md-4">
          <select [(ngModel)]="criteria.Sort" (change)="load()">
            <option value="0">زمان ارسال</option>
            <option value="1">وضعیت</option>
            <option value="2">امتیاز</option>
          </select>

        </div>
      </div>
      <section class="">
        <ng-container *ngFor="let apply of applies; let i=index">
          <div class="row kp-card">
            <div data-toggle="collapse" [attr.data-target]="'#apply_'+ apply.Id">
              <header class="fs-sm f-gray row m-1">
                <div class="col-12 col-sm-6">{{apply.RegisterTime|pdate}}</div>
                <div class="col-12 col-sm-6">
                  <ng-container [ngSwitch]="apply.Status"> وضعیت:
                    <span *ngSwitchCase="0" class="">بررسی نشده</span>
                    <span *ngSwitchCase="1" class="f-blue">تایید شده</span>
                    <span *ngSwitchCase="2" class="f-red">رد شده</span>
                    <span *ngSwitchCase="3" class="f-green">استخدام شده</span>
                  </ng-container>
                  <span [ngSwitch]="apply.Score" class="mr-1"> امتیاز:
                    <span *ngSwitchCase="0" class="f-red">ضعیف</span>
                    <span *ngSwitchCase="5" class="">متوسط</span>
                    <span *ngSwitchCase="10" class="f-green">خوب</span>
                  </span>

                </div>
              </header>
              <h3 class="mb-2">
                <a *ngIf="apply.User?.code" [routerLink]="['/resume',apply.User.code]"
                  target="_blank">{{apply.User.name || apply.User.mobile || apply.User.username }} </a>
                <ng-container *ngIf="!apply.User?.code">{{apply.Name || apply.Mobile }}</ng-container>
              </h3>
            </div>

            <div [id]="'apply_'+ apply.Id" class="collapse user-info">
              <div class="row" *ngIf="apply.User">
                <div class="col-12 col-md-6" *ngIf="apply.User.mobile || apply.User.username">
                  <h6> شماره موبایل:</h6> <a class="btn btn-link p-0"
                    href="tel:{{apply.User.mobile || apply.User.username}}"><span
                      class="fs-lg">{{apply.User.mobile || apply.User.username}}</span></a>
                </div>
                <div class="col-12 col-md-6" *ngIf="apply.User.email">
                  <h6>ایمیل:</h6> <a class="btn btn-link p-0" href="mailto:{{apply.User.email}}"><span
                      class="fs-lg">{{apply.User.email}}</span></a>
                </div>
              </div>
              <ng-container *ngIf="!apply.User">
                <div *ngIf="apply.Mobile">
                  <h6> شماره موبایل:</h6> <a class="btn btn-link p-0" href="tel:{{apply.Mobile}}">{{apply.Mobile}}</a>
                </div>
                <div *ngIf="apply.Email">
                  <h6>ایمیل:</h6> <a class="btn btn-link" href="mailto:{{apply.Email}}">{{apply.Email}}</a>
                </div>
                <div *ngIf="apply.City">
                  <h6>شهر محل اقامت:</h6> {{apply.State}}، {{apply.City}}
                </div>
                <div *ngIf="apply.District">
                  <h6>محله:</h6> {{apply.District}}
                </div>
                <div *ngIf="apply.Education">
                  <h6>مدرک تحصیلی:</h6> {{apply.Education}}
                </div>
                <div *ngIf="apply.Background">
                  <h6>سوابق کاری:</h6>

                  <p class="mb-0">{{apply.Background}}</p>

                </div>
                <div *ngIf="apply.Description">
                  <h6>سایر توضیحات:</h6>

                  <p class="mb-0">{{apply.Description}}</p>

                </div>
              </ng-container>
              <a class="btn btn-blue mb-2" target="_blank" *ngIf="apply.User?.code"
                [routerLink]="['/resume',apply.User.code]">
                <h6 class="d-inline">مشاهده رزومه آنلاین</h6>
              </a>

              <h5 class="col-12 mt-3">نظر کارفرما <span class="f-red fs-sm">(نظر کارفرما محرمانه است و توسط کارجو قابل
                  مشاهده نیست.)</span></h5>
              <section class="row mx-0 my-1 alert alert-primary">
                <label class="col-12 col-md-6 pr-0">
                  <h6>وضعیت درخواست:</h6>
                  <select [(ngModel)]="apply.Status" (change)="update(apply)">
                    <option value="0">بررسی نشده</option>
                    <option value="1">تایید شده</option>
                    <option value="2">رد شده</option>
                    <option value="3">استخدام شده</option>
                  </select>
                </label>
                <label class="col-12 col-md-6 pl-0">
                  <h6>امتیاز کارجو:</h6>
                  <select [(ngModel)]="apply.Score" (change)="update(apply)">
                    <option value="0">ضعیف</option>
                    <option value="5">متوسط</option>
                    <option value="10">خوب</option>
                  </select>
                </label>
                <div class="col-12 p-0">
                  <h6>یادداشت ها: <span class="f-gray fs-sm"></span></h6>
                  <textarea rows="2" placeholder="یادداشت..." [(ngModel)]="apply.EmployerNotes"
                    (change)="update(apply)"></textarea>
                </div>
              </section>

            </div>
          </div>
        </ng-container>
      </section>
      <div class="col">
        <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
      </div>
    </div>
  </div>
</section>